export default "https://cdn-static.gokick.com/assets/dbba9902646848f8f0b834a64aaa98666d1f7693/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";